import axios from 'axios';
import config from '../common/config';

/**
 * The caller's OWN WhatsApp link. Account-scoped on purpose: the response
 * carries link_code and the wa.me URL, and whoever sends that code binds
 * THEIR phone to this account -- so there is deliberately no ride in any of
 * these paths. A ride's own settings response carries only the masked phone.
 */
export default {
  getLink( token ) {
    return axios.get(`${config.config.ROOT_URL}/api/whatsapp/account_link`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  createLink( token, language ) {
    return axios.post(`${config.config.ROOT_URL}/api/whatsapp/account_link`,
      { language }, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
  },
  deleteLink( token ) {
    return axios.delete(`${config.config.ROOT_URL}/api/whatsapp/account_link`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  }
};
